// store/modules/settime.js
import api from '@/service/api'
import moment from 'moment-timezone'

export default {
    namespaced: true,
    state: {
        setters: []
    },
    mutations: {
        setSetters(state, payload) {
            state.setters = payload
        }
    },
    actions: {
        async fetchSetters({ commit }) {
            const res = await api.setter('get')
            const data = res?.data?.data || []
            const formatted = data.map(s => ({
                _id: s._id,
                eventName: s.title?.event_name || s.title,
                typeName: s.type?.type_name || s.type,
                startDate: moment(s.startDate).tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm"),
                endDate: moment(s.endDate).tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm"),
            }))
            commit('setSetters', formatted)
        },

        async deleteSetter(_, id) {
            const res = await api.setter('delete', { id })
            return res.data?.data
        },

        async updateSetter(_, payload) {
            const res = await api.setter('put', payload)
            return res.data?.data
        }
    }
}
